import { isDesktop } from '@/const/version';

export const desktopRemoteRPCFetch = async (_input: string, _init?: RequestInit) => {
  return undefined;
};

export const fetchWithDesktopRemoteRPC = async (input: string, init?: RequestInit) => {
  if (isDesktop) {
    const res = await desktopRemoteRPCFetch(input, init);
    if (res) return res;
  }

  return fetch(input, init);
};
